import Callout from "../Callout/Callout";
/**
 * The dialog body's notification row — `Callout` under the name of its zone, so a body
 * reads as `Banner`. Forwards every prop, adds no behaviour: an INSET body row, never a full-bleed band.
 */
const Banner = Callout;
export default Banner;
//# sourceMappingURL=DialogBanner.js.map